export default __webpack_public_path__ + "static/media/tsa-favicon.f747570a.ico";